import axios from "axios";

// dashboard order table data
export const fetchPaymentOrders = (dealerId, paymentStatus, sortOrder, sortBy,token) => async (dispatch) => {
    try {
        dispatch({ type: 'ORDERS_REQUEST' });

        const { data } = await axios.get(
            `${process.env.REACT_APP_DP_API}/api/dealer-portal/orders`,
            {
                params: {
                    page: 1,
                    limit: 10,
                    dealerId,
                    paymentStatus
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                  },
            }
        );

        const sortedOrders = data.orders.sort((a, b) => {
            if (sortOrder === 'asc') {
                return a[sortBy] > b[sortBy] ? 1 : -1;
            }
            return a[sortBy] < b[sortBy] ? 1 : -1;
        });

        dispatch({
            type: 'ORDERS_SUCCESS',
            payload: sortedOrders
        });
    } catch (error) {
        dispatch({
            type: 'ORDERS_FAIL',
            payload: error.response && error.response.data.message ? error.response.data.message : error.message
        });
    }
};


// Order table Dashboard
export const FETCH_ORDERS_REQUEST = 'FETCH_ORDERS_REQUEST';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAIL = 'FETCH_ORDERS_FAIL';
export const SET_TAB_VALUE = 'SET_TAB_VALUE';
export const SET_ORDER_BY = 'SET_ORDER_BY';
export const SET_ORDER = 'SET_ORDER';

// actions/DashboardActions.js

export const fetchOrders = (params = {}, token) => async (dispatch) => {
    try {
        dispatch({ type: FETCH_ORDERS_REQUEST });

        const { data } = await axios.get(
            `${process.env.REACT_APP_DP_API}/api/dealer-portal/orders`,
            {
                params,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        dispatch({ type: FETCH_ORDERS_SUCCESS, payload: data.orders });
    } catch (error) {
        dispatch({
            type: FETCH_ORDERS_FAIL,
            payload: error.response && error.response.data.message ? error.response.data.message : error.message
        });
    }
};


export const setTabValue = (tabValue) => ({
    type: SET_TAB_VALUE,
    payload: tabValue
});

export const setOrderBy = (orderBy) => ({
    type: SET_ORDER_BY,
    payload: orderBy
});

export const setOrder = (order) => ({
    type: SET_ORDER,
    payload: order
});

//dashboard stats data

export const FETCH_DASHBOARD_STATS_REQUEST = 'FETCH_DASHBOARD_STATS_REQUEST';
export const FETCH_DASHBOARD_STATS_SUCCESS = 'FETCH_DASHBOARD_STATS_SUCCESS';
export const FETCH_DASHBOARD_STATS_FAIL = 'FETCH_DASHBOARD_STATS_FAIL';

export const fetchDashboardStats = (dealerId, month,token) => async (dispatch) => {
    dispatch({ type: FETCH_DASHBOARD_STATS_REQUEST });

    try {
        const response = await axios.get(`${process.env.REACT_APP_DP_API}/api/dealer-portal/dealer-dashboard-data`, {
            params: {
                month: month,
                dealerId: dealerId
            },
            headers: {
                Authorization: `Bearer ${token}`,
              },
        });
        dispatch({
            type: FETCH_DASHBOARD_STATS_SUCCESS,
            payload: response.data
        });
    } catch (error) {
        dispatch({
            type: FETCH_DASHBOARD_STATS_FAIL,
            payload: error.response && error.response.data.message ? error.response.data.message : error.message
        });
    }
};